import { useMemo } from "react";
import { useSelector } from "react-redux";

import { dataMetaSelector } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { IAPIState } from "shared/types";

export const useFetchingUserDocuments = () => {
  const { api: passportApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserPassports)
  );
  const { api: visaApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserTravelVisas)
  );
  const { api: formApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserSocialSecurityForms)
  );
  const { api: permitApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserDrivingPermits)
  );
  const { api: vehicleApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserVehicles)
  );
  const { api: loyaltyApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserLoyaltyPrograms)
  );

  const fetchingPassports = useMemo(() => {
    return passportApi?.status === IAPIState.pending;
  }, [passportApi]);

  const fetchingTravelVisas = useMemo(() => {
    return visaApi?.status === IAPIState.pending;
  }, [visaApi]);

  const fetchingSocialSecurityForms = useMemo(() => {
    return formApi?.status === IAPIState.pending;
  }, [formApi]);

  const fetchingDrivingPermits = useMemo(() => {
    return permitApi?.status === IAPIState.pending;
  }, [permitApi]);

  const fetchingVehicles = useMemo(() => {
    return vehicleApi?.status === IAPIState.pending;
  }, [vehicleApi]);

  const fetchingLoyaltyPrograms = useMemo(() => {
    return loyaltyApi?.status === IAPIState.pending;
  }, [loyaltyApi]);

  const fetchingUserDocuments = useMemo(() => {
    return (
      fetchingPassports ||
      fetchingTravelVisas ||
      fetchingSocialSecurityForms ||
      fetchingDrivingPermits ||
      fetchingVehicles
    );
  }, [
    fetchingSocialSecurityForms,
    fetchingDrivingPermits,
    fetchingPassports,
    fetchingTravelVisas,
    fetchingVehicles,
  ]);

  return {
    fetchingSocialSecurityForms,
    fetchingDrivingPermits,
    fetchingPassports,
    fetchingTravelVisas,
    fetchingVehicles,
    fetchingUserDocuments,
    fetchingLoyaltyPrograms,
  };
};
